jQuery(document).ready(function ($) {
  // 使用事件委托来监听所有可能的点击

// 限定在当前产品价格容器内读取，避免读到其他产品卡片的价格
const $productPrice = $(".product__price .price");

// 划线原价：s 标签本身有 price-item--regular 这个 class
const $strikethroughEl = $productPrice.find("s.price-item--regular");

// 现价
const $salePriceEl = $productPrice.find(".price-item--sale.price-item--last");

// 无折扣时的价格
const $regularOnlyEl = $productPrice.find(".price__regular .price-item--regular");

if ($strikethroughEl.length > 0) {
    originalVariantRegularPrice = parseFloat($strikethroughEl.first().text().replace(/[^0-9.]/g, '')) || 0;
    originalVariantSalePrice = parseFloat($salePriceEl.first().text().replace(/[^0-9.]/g, '')) || 0;
} else {
    originalVariantRegularPrice = parseFloat($regularOnlyEl.first().text().replace(/[^0-9.]/g, '')) || 0;
    originalVariantSalePrice = originalVariantRegularPrice;
}

console.log('初始原价(划线):', originalVariantRegularPrice, '初始售价:', originalVariantSalePrice);
    
  let originalQuantity = 1;
  var productInputs = {};
  //产品详情页价格获取
  var $initPrice = $(".product__price .price .price-item").html();
  //获取元字段数据
  const metafieldsJson = document.getElementById("product-metafields");
  let metafields = {};
  if (metafieldsJson) {
        metafields = JSON.parse(metafieldsJson.textContent);
    }

function updatePriceDisplay(newPrice, inputs, mode) {
  const $priceWrapper = $(".product__price .price");
  const quantity = inputs.quantity || 1;

  function formatPrice(price) {
    return '<span class="woocommerce-Price-currencySymbol">$</span>' + price.toFixed(2);
  }

  // 使用页面加载时保存的原始价格计算折扣比例
  const discountRatio = (originalVariantRegularPrice > 0 && originalVariantSalePrice > 0 && originalVariantSalePrice < originalVariantRegularPrice)
    ? originalVariantSalePrice / originalVariantRegularPrice
    : 1;

  const calculatedSalePrice = newPrice;
  const calculatedRegularPrice = discountRatio < 1
    ? newPrice / discountRatio
    : 0;

  function getPanelText(price) {
    if (inputs.panelType === "Split Panels") {
      return `${quantity} × ${formatPrice(price)}`;
    } else {
      if (price > 0) {
        const panel = quantity > 1 ? 'pieces' : 'Piece';
        return `${quantity} ${panel} × ${formatPrice(price)}`;
      } else {
        return $initPrice;
      }
    }
  }

  if (discountRatio < 1 && calculatedRegularPrice > 0) {
    $priceWrapper.removeClass('price--no-sale').addClass('price--on-sale');
    $priceWrapper.find('s.price-item--regular').html(formatPrice(calculatedRegularPrice));
    $priceWrapper.find('.price__sale .price-item--sale').html(getPanelText(calculatedSalePrice));
    const saveAmount = calculatedRegularPrice - calculatedSalePrice;
    $priceWrapper.find('.price__badge-sale').text('Save $' + saveAmount.toFixed(2));
  } else {
    $priceWrapper.removeClass('price--on-sale').addClass('price--no-sale');
    $priceWrapper.find('.price__regular .price-item--regular').html(getPanelText(calculatedSalePrice));
  }

  $("#fetch_color_res_txt").html(inputs.colorSwatch || "");
  $("#fetch_width_res_txt").html(inputs.width ? inputs.width.toFixed(2) + '"' : "");
  $("#fetch_length_res_txt").html(inputs.height ? inputs.height.toFixed(2) + '"' : "");
  $("#fetch_header_res_txt").html(inputs.header || "");
  $("#fetch_lining_res_txt").html(inputs.lining || "");
}

function handleCurtainCalculation(isAddToCart = false, updatePriceStr = "") {
    // 获取所有必要的输入值
    const inputs = {
      productId: $('input[name="product-id"]').val(),
      variation_id: $('input[name="id"]').val() || 0,
      colorSwatch: $(".variant-picker__color").val() || "",
      method: $('input[name="mtsi_method"]:checked').val(),
      header: $('input[name="mtsi_header_type"]:checked').val(),
      width: parseFloat($("#mtsi_custom_curtain_width").val()),
      height: parseFloat($("#mtsi_custom_curtain_height").val()),
      width_eighths: $("select[name='width_eighths']").val(),
      height_eighths: $("select[name='height_eighths']").val(),
      unit: 'inches',
      panelType: $('input[name="mtsi_panel_type"]:checked').val(),
      mountType: $('input[name="mtsi_mount_type"]:checked').val(),
      liftControl: $('input[name="mtsi_lift_control"]:checked').val(),
      edgeBinding: $('input[name="mtsi_edge_binding"]:checked').val(),
      liningOption: $('input[name="mtsi_lining_option"]:checked').val(),
      quantity: parseInt($('.quantity input[name="quantity"]').val() || "1"),
      lining: $('input[data-name="mtsi_custom_curtain_lining"]:checked').val(),
      liningColor:
        $('input[data-name="mtsi_liner_color_swatch"]:checked').attr(
          "data-color-name"
        ) || "",
      linerUnitPrice: parseFloat(metafields.liner_unit_price) || 0,
      fabricUnitPrice: parseFloat(metafields.fabric_unit_price) || 0,
      gramPerSquareInches: parseFloat(metafields.gram_per_square_inches) || 0,
      linerGramPerSquareInches: parseFloat(metafields.liner_gram_per_square_inches) || 0,
      patternType: "vertical",
      exchangeRate: parseFloat(1 / 7.0),
      startValue: 'YES',
    };
    productInputs = inputs;

    const variantData = JSON.parse(
      document.querySelector('variant-selects script[type="application/json"]').textContent
    );

    // 获取当前选中的 Color 值
    const selectedColor = document.querySelector('input[name="Color"]:checked')?.value;

    // 找到对应变体
    const currentVariant = variantData.find(v => v.option1 === selectedColor);
    const currentSku = currentVariant?.sku;

    console.log('当前SKU:', currentSku);
    // Split Panels 数量调整
    if (updatePriceStr != "") {
      if (inputs.panelType == "Split Panels") {
        inputs.quantity *= 2;
      }
    } else {
      if (inputs.panelType === "Split Panels") {
        if (inputs.quantity * 2 == originalQuantity) {
          inputs.quantity *= 2;
        }
      } else {
        if (inputs.quantity === originalQuantity) {
          inputs.quantity = originalQuantity;
          $('input[name="quantity"]').val(inputs.quantity);
        }
      }
    }

    // ============================================================
    // 新计算公式
    // ============================================================
    const craftWidth  = inputs.width;   // inch
    const craftHeight = inputs.height;  // inch
    const fabricUnitPrice     = inputs.fabricUnitPrice;      // RMB/平方米
    const gramPerSqIn         = inputs.gramPerSquareInches;  // g/平方英寸
    const isMotorized         = inputs.liftControl === 'Motorized';
    const hasEdgeBinding      = inputs.edgeBinding && inputs.edgeBinding !== 'No Edge Binding';
    const hasLining           = inputs.lining && inputs.lining !== 'Unlined';

    // G2 面料成本 = MAX(宽m × 高m, 1) × 面料单价
    const widthM   = craftWidth  * 0.0254;
    const heightM  = craftHeight * 0.0254;
    const realArea = widthM * heightM;
    const billedArea = Math.max(realArea, 1);  // 不足1平方米按1算
    const fabricCost = billedArea * fabricUnitPrice;
    console.log("G2 fabricCost:", fabricCost);

    // H2 分拼费：幅数 N = ROUNDUP(宽m / 1.8, 0)
    // N=1: 0元  N=2: 7元  N=3: 9元  N>=2: 7+(N-2)*2
    const panelCount = Math.ceil(widthM / 1.8);
    const splicingFee = panelCount >= 2 ? 7 + (panelCount - 2) * 2 : 0;
    console.log("H2 panelCount:", panelCount, "splicingFee:", splicingFee);

    // I2 总重量KG = (宽inch × 高inch × 克重g/sqin) / 1000 + 1 + IF(电动, 0.5×幅数, 0)
    const fabricWeightKg = (craftWidth * craftHeight * gramPerSqIn) / 1000;
    const motorWeightKg  = isMotorized ? 0.5 * panelCount : 0;
    const totalWeightKg  = fabricWeightKg + 1 + motorWeightKg;
    console.log("I2 totalWeightKg:", totalWeightKg);

    // 完整运费合同（向上匹配）
    const shippingTable = [
      [0.5,  264.865], [1.0,  281.26],  [1.5,  297.915], [2.0,  340.7],
      [2.5,  383.251], [3.0,  407.433], [3.5,  446.747], [4.0,  486.061],
      [4.5,  525.375], [5.0,  564.689], [5.5,  548.935], [6.0,  584.115],
      [6.5,  619.295], [7.0,  654.475], [7.5,  689.655], [8.0,  724.835],
      [8.5,  760.015], [9.0,  795.195], [9.5,  830.375], [10.0, 865.555],
      [10.5, 995.154], [11.0, 1032.479],[11.5, 1069.804],[12.0, 1107.129],
      [12.5, 1144.454],[13.0, 1181.779],[13.5, 1219.104],[14.0, 1256.429],
      [14.5, 1293.754],[15.0, 1331.079],[15.5, 1368.404],[16.0, 1405.729],
      [16.5, 1443.054],[17.0, 1480.379],[17.5, 1517.704],[18.0, 1555.029],
      [18.5, 1592.354],[19.0, 1629.68], [19.5, 1667.00], [20.0, 1704.33],
      [20.5, 1990.70], [21.0, 2021.65], [21.5, 2052.61], [22.0, 2083.56],
      [22.5, 2114.52], [23.0, 2145.47], [23.5, 2176.43], [24.0, 2207.38],
      [24.5, 2238.34], [25.0, 2269.29], [25.5, 2300.25], [26.0, 2331.20],
      [26.5, 2362.16], [27.0, 2393.11], [27.5, 2424.07], [28.0, 2455.02],
      [28.5, 2485.98], [29.0, 2516.93], [29.5, 2547.89], [30.0, 2578.84],
    ];

    // J2 运费：向上取整匹配（totalWeightKg 超过某档则取下一档）
    function getFreight(weightKg) {
      for (let i = 0; i < shippingTable.length; i++) {
        if (weightKg <= shippingTable[i][0]) {
          return shippingTable[i][1];
        }
      }
      // 超出最大档位，取最大值
      return shippingTable[shippingTable.length - 1][1];
    }
    const freight = getFreight(totalWeightKg);
    console.log("J2 freight:", freight);

    // K2 超长附加费：宽高中最大值 > 48 inch 加 90 元
    const surcharge = (Math.max(craftWidth, craftHeight) > 48) ? 90 : 0;
    console.log("K2 surcharge:", surcharge);

    // M2 包边费：选了包边时，高度 ≤ 2m 加15元，> 2m 加30元
    const edgeBindingFee = hasEdgeBinding ? (heightM <= 2 ? 15 : 30) : 0;
    console.log("M2 edgeBindingFee:", edgeBindingFee);

    // O2 电机费 = 359 + MAX(面积, 1) × 10
    const motorFee = isMotorized ? (359 + billedArea * 10) : 0;
    console.log("O2 motorFee:", motorFee);

    // Q2 衬布费 = MAX(面积, 1) × 55（不足1平米按1平米）
    const liningFee = hasLining ? (billedArea * 55) : 0;
    console.log("Q2 liningFee:", liningFee);

    // R2 总成本USD = (G + H + J + K + M + O + Q) / 7
    const totalCostUSD = (fabricCost + splicingFee + freight + surcharge + edgeBindingFee + motorFee + liningFee) / 7;
    console.log("R2 totalCostUSD:", totalCostUSD);

    // S2 最终售价 = R2 × 4
    //20260413 利润系数从4改成2.5倍
    let totalPrice = totalCostUSD * 2.5;
    totalPrice = Math.floor(totalPrice * 100) / 100;
    console.log("S2 totalPrice:", totalPrice);

    inputs.totalPrice = totalPrice;

    // ============================================================
    // 传值到隐藏表单、更新UI（保持不变）
    // ============================================================
    document.getElementById('hiddenMountType').value = inputs.mountType ?? '';
    document.getElementById('hiddenWidth').value = inputs.width + ' ' + inputs.width_eighths + '"' ?? '';
    document.getElementById('hiddenHeight').value = inputs.height + ' ' + inputs.height_eighths + '"' ?? '';
    document.getElementById('hiddenLiftControl').value = inputs.liftControl ?? '';
    document.getElementById('hiddenLining').value = inputs.lining ?? '';
    document.getElementById('hiddenLinerColor').value = inputs.liningColor ?? '';
    document.getElementById('hiddenEdgeBinding').value = inputs.edgeBinding ?? '';
    var appPriceInput = document.getElementById('custom-price-field');
    if (appPriceInput) {
      appPriceInput.value = totalPrice;
    }

    $(".new-xqy .color").html(inputs.colorSku);
    $(".new-xqy .mountType").html(inputs.mountType);
    $(".new-xqy .liftControl").html(inputs.liftControl);
    $(".new-xqy .lining").html(inputs.lining);
    $(".new-xqy .edge_binding").html(inputs.edgeBinding);

    if (inputs.width && inputs.height) {
      $(".width_height_html").html(inputs.width + ' ' + inputs.width_eighths + '"W x ' + inputs.height + ' ' + inputs.height_eighths + '"L');
      $('.kuangao').css('border', 'none');
    } else {
      $(".width_height_html").html('');
      $('.kuangao').css('border', '1px dashed red');
    }

    if (inputs.mountType == 'Inside') {
      $('.kuangao-img img').attr("src", 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Inside-Mount-measuring-min.png?v=1766975679');
      $('.note-text').html('. Width: Measure widths at top, middle, and bottom inside the window; use the smallest one & deduct 3/8".<br> · Length: Measure heights at left, center, right inside the window; use the largest measurement.');
      $('input[value="Cordless"]').siblings('span').find('img')
        .attr('src', 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Inside-Mount-manual-cordless-min.png?v=1766742344');
      $('input[value="Motorized"]').siblings('span').find('img')
        .attr('src', 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Inside-Mount-motorized-min.png?v=1766742381');
    } else if (inputs.mountType == 'Outside') {
      $('.kuangao-img img').attr("src", 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Outside-Mount-measuring-min.png?v=1766975874');
      $('.note-text').html('· Width: Measure widths at top, middle, and bottom inside the window; use the largest one and add  2-4 inches for optimal coverage.<br> · Height: Measure from your desired mounting point down to the desired bottom. Recommend: 4-6 inches above the window frame.');
      $('input[value="Cordless"]').siblings('span').find('img')
        .attr('src', 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Outside-Mount-manual-cordless-min.png?v=1766975915');
      $('input[value="Motorized"]').siblings('span').find('img')
        .attr('src', 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Outside-Mount-motorized-min.png?v=1766975945');
    }

    if (currentSku.includes('-c-')) {
      $('input[data-name="mtsi_custom_curtain_lining"][value="Liner"]').prop("disabled", true);
    }

    checkAllOptionsSelected();
    if (totalPrice) {
      updatePriceDisplay(totalPrice, inputs, inputs.startValue);
    }
  }
  //初始化计算
  handleCurtainCalculation();
  //分界线
  function checkAllOptionsSelected() {
    var allSelected = true;

    if (!productInputs.mountType || !productInputs.liftControl) {
      allSelected = false;
    }

    // Check if width and height are entered and valid
    var minwidthValue = 10;
    var minheightValue = 20;
    var maxValue = 150;
    var maxHeight = 200;
    if (!(productInputs.width && productInputs.width >= minwidthValue && productInputs.width <= maxValue && productInputs.height && productInputs.height >= minheightValue && productInputs.height <= maxHeight)) {
      allSelected = false;
    }

    // 根据 value 定位
    let cordlessOption = document.querySelector('input[type="radio"][name="mtsi_lift_control"][value="Cordless"]');
    let motorizedOption = document.querySelector('input[type="radio"][name="mtsi_lift_control"][value="Motorized"]');

    // 父级 span（用于插入提示）
    let cordlessWrapper = cordlessOption.closest(".wpcf7-list-item");
    let motorizedWrapper = motorizedOption.closest(".wpcf7-list-item");

    // 删除旧的提示
    document.querySelectorAll(".option-warning").forEach(el => el.remove());

    // Cordless 限制
    if ((Number(productInputs.width) < 10 || Number(productInputs.width) > 150) || (Number(productInputs.height) < 20 || Number(productInputs.height) > 200)) {
        cordlessOption.disabled = true;
        //cordlessOption.checked = false;

        //let warning = document.createElement("div");
        //warning.className = "option-warning";
        //warning.style.color = "red";
        //warning.textContent = "Cordless option is unavailable for widths over 94 inches.";
        //cordlessWrapper.insertAdjacentElement("beforebegin", warning);
    } else {
        cordlessOption.disabled = false;
        console.log('cordless 占位');
        //cordlessOption.checked = true;
    }

    // Motorized 限制
    if ((Number(productInputs.width) < 24 || Number(productInputs.width) > 150) || (Number(productInputs.height) < 20 || Number(productInputs.height) > 200)) {
        motorizedOption.disabled = true;
        //motorizedOption.checked = false;

    } else {
        motorizedOption.disabled = false;
        console.log('motorized 占位');
        //motorizedOption.checked = true;
    }

    var $addToCartButton = $(".product-form__submit");
    if (allSelected) {
      $addToCartButton.prop("disabled", false);
      $addToCartButton.removeClass("disabled");
    } else {
      $addToCartButton.prop("disabled", true);
      $addToCartButton.addClass("disabled");
    }
    return allSelected;
  }

  //加入购物车，已弃用
  function addToCart(adjustedInputs, totalPrice) {
    // 检查是否所有必要的字段都已填写
    if (
      !adjustedInputs.mountType ||
      !adjustedInputs.liftControl ||
      isNaN(adjustedInputs.width) ||
      isNaN(adjustedInputs.height)
    ) {
      alert("Please fill in all required fields!");
      return;
    }

    if (!adjustedInputs.colorSwatch) {
      alert("Please choose a color");
      return false;
    }
    const cartData = {
      action: "cstm_add_to_cart",
      product_id: adjustedInputs.productId,
      variation_id: adjustedInputs.variation_id,
      msti_pattern_type: adjustedInputs.patternType,
      mtsi_color_sku: adjustedInputs.colorSku,
      mtsi_color_swatch: adjustedInputs.colorSwatch,
      mtsi_mount_type: adjustedInputs.mountType,
      mtsi_lift_control: adjustedInputs.liftControl,
      mtsi_custom_curtain_width: adjustedInputs.width,
      mtsi_custom_curtain_height: adjustedInputs.height,
      width_eighths: adjustedInputs.width_eighths,
      height_eighths: adjustedInputs.height_eighths,
      mtsi_custom_curtain_unit: adjustedInputs.unit,
      quantity: adjustedInputs.quantity,
      mtsi_custom_curtain_lining: adjustedInputs.lining,
      mtsi_custom_curtain_lining_color: adjustedInputs.liningColor,
      security: ajax_object.nonce,
      calculated_price: totalPrice,
      startValue: adjustedInputs.startValue,
    };

    $.ajax({
      url: ajax_object.ajax_url,
      type: "POST",
      data: cartData,
      beforeSend: function () {
        var $addToCartButton = $(".single_add_to_cart_button");
        $addToCartButton.prop("disabled", true);
        $addToCartButton.addClass("disabled");
      },
      success: function (response) {
        if (response.success) {
          localStorage.setItem("NEWCARTADDITEM", "1");
          location.reload();
        } else {
          alert(response.data.msg);
          var $addToCartButton = $(".single_add_to_cart_button");
          $addToCartButton.prop("disabled", false);
          $addToCartButton.removeClass("disabled");
        }
      },
      error: function (xhr, status, error) {
        alert("An error occurred: " + error);
        var $addToCartButton = $(".single_add_to_cart_button");
        $addToCartButton.prop("disabled", false);
        $addToCartButton.removeClass("disabled");
      },
    });
  }

  var $addToCartButton = $(".single_add_to_cart_button");
  $addToCartButton.on("click", function (e) {
    handleCurtainCalculation(false);
    e.preventDefault();
    addToCart(productInputs, productInputs.totalPrice);
  });
  //加入购物车到此结束

  $('input[name="mtsi_mount_type"] , input[name="mtsi_lift_control"] ,input[data-name="mtsi_custom_curtain_lining"], #mtsi_custom_curtain_width , #mtsi_custom_curtain_height , select[name="width_eighths"] , select[name="height_eighths"], input[name="mtsi_edge_binding"], .quantity input.quantity__input').on("change", function () {
    handleCurtainCalculation(false);
  });

    //变体颜色切换会把价格更改成变体价格，需要等待shopify的更改价格函数执行后，才可以触发更改价格
$('input[name="Color"]').on("change", function () {        
    setTimeout(() => {
        const $productPrice = $(".product__price .price");
        const $newStrikethrough = $productPrice.find("s.price-item--regular");
        const $newSalePrice = $productPrice.find(".price-item--sale.price-item--last");
        
        if ($newStrikethrough.length > 0) {
            originalVariantRegularPrice = parseFloat($newStrikethrough.first().text().replace(/[^0-9.]/g, '')) || 0;
            originalVariantSalePrice = parseFloat($newSalePrice.first().text().replace(/[^0-9.]/g, '')) || 0;
        } else {
            originalVariantRegularPrice = parseFloat($productPrice.find(".price__regular .price-item--regular").first().text().replace(/[^0-9.]/g, '')) || 0;
            originalVariantSalePrice = originalVariantRegularPrice;
        }
        console.log('变体切换后 - 原价:', originalVariantRegularPrice, '售价:', originalVariantSalePrice);
        handleCurtainCalculation(false);
    }, 1000);
});

  $('#mtsi_custom_curtain_width , #mtsi_custom_curtain_height').keypress(function(event){
    handleCurtainCalculation(false);
    if (event.which === 13) {
      event.preventDefault();
    }
  })
  //失去焦点时
  $('#mtsi_custom_curtain_width , #mtsi_custom_curtain_height').blur(function(){
          if($("#mtsi_custom_curtain_width").val()){
            $('.wpcf7-not-valid-tip1').css('visibility','hidden');
          }else{
            $('.wpcf7-not-valid-tip1').css('visibility','visible');
          }
          if($("#mtsi_custom_curtain_width").val() && $("#mtsi_custom_curtain_width").val() < 10 || $("#mtsi_custom_curtain_width").val() > 150){
            $('.wpcf7-not-valid-tip-min').css('display','block');
            $('.wpcf7-not-valid-tip1').css('display','none');
          }else{
            $('.wpcf7-not-valid-tip-min').css('display','none');
            $('.wpcf7-not-valid-tip1').css('display','initial');
          }
          if($("#mtsi_custom_curtain_height").val()){
            $('.wpcf7-not-valid-tip2').css('visibility','hidden');
          }else{
            $('.wpcf7-not-valid-tip2').css('visibility','visible');
          }
          if($("#mtsi_custom_curtain_height").val() && $("#mtsi_custom_curtain_height").val() < 10 || $("#mtsi_custom_curtain_height").val() > 200){
            $('.wpcf7-not-valid-tip-max').css('display','block');
            $('.wpcf7-not-valid-tip2').css('display','none');
          }else{
            $('.wpcf7-not-valid-tip-max').css('display','none');
            $('.wpcf7-not-valid-tip2').css('display','initial');
          }
    handleCurtainCalculation(false);
  });

  var exec5 = 0;

  setTimeout(function () {
    if (exec5 == 0) {
      exec5 = 1;

      if (localStorage.getItem("NEWCARTADDITEM")) {
        $(".lakit-cart__heading-link").click();

        localStorage.removeItem("NEWCARTADDITEM");
      }

      if (
        $("form.woocommerce-checkout ul.uael-order-review-table li + a")
          .length
      ) {
        $(
          "form.woocommerce-checkout ul.uael-order-review-table li.table-row.cart_item.st-item-meta > a:first-child"
        ).remove();

        $("form.woocommerce-checkout ul.uael-order-review-table li + a").each(
          function () {
            $(this).remove();
          }
        );
      }
    }
  }, 1500);

});
